export default __webpack_public_path__ + "static/media/Route_1_Pipeline_to_Piti_Tank_Farm.add4b6de.jpg";